/* @flow */
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';
import { Map, List, fromJS } from 'immutable';

import * as ActionTypes from './action-types.js';
import {
  NotificationPreferences,
  WatchedKeywords,
  toWatchedKeywords,
  toNotificationPreferences,
} from './types';

import type {
  NotificationPreferencesType,
  WatchedKeywordType,
  WatchedKeywordsType
} from './types.js';

export const notificationPreferences = (state: NotificationPreferencesType = NotificationPreferences(), action: Action<NotificationPreferencesType>) => {
  switch (action.type) {
  case ActionTypes.FETCH_PREFERENCES_SUCCESS:
    return fromJS(action.payload, toNotificationPreferences);
  default:
    return state;
  }
};

export const watchedKeywords = (state: WatchedKeywordsType = List(), action: Action<WatchedKeywordType | WatchedKeywordsType>) => {
  switch (action.type) {
  case ActionTypes.FETCH_WATCHED_KEYWORDS_SUCCESS:
    return fromJS(action.payload, toWatchedKeywords);
  default:
    return state;
  }
};

export const loading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case ActionTypes.FETCH_PREFERENCES:
  case ActionTypes.UPDATE_PREFERENCES:
  case ActionTypes.FETCH_WATCHED_KEYWORDS:
  case ActionTypes.ADD_WATCHED_KEYWORD:
  case ActionTypes.DELETE_WATCHED_KEYWORD:
    return true;
  case ActionTypes.FETCH_PREFERENCES_SUCCESS:
  case ActionTypes.UPDATE_PREFERENCES_SUCCESS:
  case ActionTypes.FETCH_WATCHED_KEYWORDS_SUCCESS:
  case ActionTypes.FETCH_WATCHED_KEYWORDS_FAILURE:
  case ActionTypes.ADD_WATCHED_KEYWORD_SUCCESS:
  case ActionTypes.ADD_WATCHED_KEYWORD_FAILURE:
  case ActionTypes.DELETE_WATCHED_KEYWORD_SUCCESS:
  case ActionTypes.DELETE_WATCHED_KEYWORD_FAILURE:
    return false;
  default:
    return state;
  }
};

export const watchedKeywordsLoading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case ActionTypes.FETCH_WATCHED_KEYWORDS:
  case ActionTypes.ADD_WATCHED_KEYWORD:
  case ActionTypes.DELETE_WATCHED_KEYWORD:
    return true;
  case ActionTypes.FETCH_WATCHED_KEYWORDS_SUCCESS:
  case ActionTypes.FETCH_WATCHED_KEYWORDS_FAILURE:
  case ActionTypes.ADD_WATCHED_KEYWORD_SUCCESS:
  case ActionTypes.ADD_WATCHED_KEYWORD_FAILURE:
  case ActionTypes.DELETE_WATCHED_KEYWORD_SUCCESS:
  case ActionTypes.DELETE_WATCHED_KEYWORD_FAILURE:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  watchedKeywordsLoading,
  notificationPreferences,
  loading,
  watchedKeywords,
});



// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/stores.js